import { Select, type SelectProps } from 'antd';
import type React from 'react';

const ALL_VALUE = 'all';

interface BrandsSelectProps {
  loading: SelectProps['loading'];
  options: SelectProps['options'];
  value?: SelectProps['value'];
  onChange?: SelectProps['onChange'];
}

export const BrandsSelect: React.FC<BrandsSelectProps> = ({ loading, options, value, onChange }) => (
  <Select
    mode="multiple"
    placeholder="Select Brands"
    allowClear
    loading={loading}
    options={
      options?.length
        ? [
            {
              value: ALL_VALUE,
              label: 'All Brands',
            },
            ...options,
          ]
        : options
    }
    optionRender={(option) => {
      if (option.value === ALL_VALUE) {
        return <div>{option.label}</div>;
      }

      const [zingPlatformName, externalBrandName] = (option.value || '').toString().split('***');

      return (
        <div>
          <div className="truncate">{externalBrandName}</div>
          <div className="truncate text-[11px]/[14px] text-gray-7 font-normal">{zingPlatformName}</div>
        </div>
      );
    }}
    value={value}
    onChange={(value: string[]) => {
      if (value?.length > 1) {
        const first = value[0];
        const last = value[value.length - 1];

        if (first === ALL_VALUE) {
          onChange?.(value.filter((v) => v !== ALL_VALUE));
        } else if (last === ALL_VALUE) {
          onChange?.(value.filter((v) => v === ALL_VALUE));
        } else {
          onChange?.(value);
        }
      } else {
        onChange?.(value);
      }
    }}
  />
);
